/**
 * @generated SignedSource<<35ccac48c867b94ea81c3f75c9c4844f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CloudApiVehicleTypeVehicleTypeEnum = "C18" | "C36" | "C93" | "DOCK_G27" | "DOCK_G47" | "E1" | "R1" | "R3" | "R47" | "R47_ISP" | "R47_XAVIER" | "R71" | "SIMULATOR" | "UNKNOWN" | "W17" | "%future added value";
export type VehicleTypeCategoriesQuery$variables = Record<PropertyKey, never>;
export type VehicleTypeCategoriesQuery$data = {
  readonly vehicleTypeCategories: {
    readonly accessPointTypes: ReadonlyArray<CloudApiVehicleTypeVehicleTypeEnum | null> | null;
    readonly controllerTypes: ReadonlyArray<CloudApiVehicleTypeVehicleTypeEnum | null> | null;
    readonly dockTypes: ReadonlyArray<CloudApiVehicleTypeVehicleTypeEnum | null> | null;
    readonly otherTypes: ReadonlyArray<CloudApiVehicleTypeVehicleTypeEnum | null> | null;
    readonly vehicleTypes: ReadonlyArray<CloudApiVehicleTypeVehicleTypeEnum | null> | null;
  } | null;
};
export type VehicleTypeCategoriesQuery = {
  response: VehicleTypeCategoriesQuery$data;
  variables: VehicleTypeCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "VehicleTypeCategories",
    "kind": "LinkedField",
    "name": "vehicleTypeCategories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vehicleTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dockTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "controllerTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessPointTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherTypes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VehicleTypeCategoriesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "VehicleTypeCategoriesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4397d25efb809eb4db09131b5be76db6",
    "id": null,
    "metadata": {},
    "name": "VehicleTypeCategoriesQuery",
    "operationKind": "query",
    "text": "query VehicleTypeCategoriesQuery {\n  vehicleTypeCategories {\n    vehicleTypes\n    dockTypes\n    controllerTypes\n    accessPointTypes\n    otherTypes\n  }\n}\n"
  }
};
})();

(node as any).hash = "285cb8f183a5bdfb9798d1c54a3cf12d";

export default node;
